import React from "react";
import LegalPage from "../components/LegalPage";

export default function GBRRules() {
  return (
    <LegalPage title="GBR Rules">
      <section>
        <h2 className="text-xl font-semibold mb-3">🎟 Earning Tickets</h2>
        <ul className="list-disc pl-5 space-y-2">
          <li>
            Tickets are awarded for each advert that is completed and confirmed
            by our third-party advert providers.
          </li>
          <li>
            Additional tickets can be earned by referring friends using your
            in-game referral code.
          </li>
          <li>
            A maximum of <strong>200 tickets</strong> can be earned per person
            each day.
          </li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3">🕛 The Daily Draw</h2>
        <ul className="list-disc pl-5 space-y-2">
          <li>
            The draw takes place daily at <strong>12:00 UTC</strong>.
          </li>
          <li>
            100 winners are randomly selected each day.
          </li>
          <li>
            Winners may choose to receive their prize as a{" "}
            <strong>Gift Card</strong>, <strong>PayPal</strong>, or{" "}
            <strong>Cryptocurrency</strong> (Kepithor Token – KEPI).
          </li>
          <li>
            Some withdrawal options may impose a minimum withdrawal amount.
          </li>
          <li>
            UK winners can choose from over{" "}
            <strong>100 different gift cards</strong>, including Amazon, Tesco,
            and Google Play.
          </li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3">
          💰 Daily Prizes (Currently £25 Prize Pool)
        </h2>
        <ul className="list-disc pl-5 space-y-1">
          <li>1st prize: £5</li>
          <li>2nd–10th prize: £1</li>
          <li>11th–30th prize: £0.20</li>
          <li>31st–100th prize: £0.10</li>
        </ul>

        <p className="mt-4">
          As the game grows, the prize pool may increase, resulting in either
          higher prizes or a greater number of winners.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3">ℹ️ More Information</h2>
        <p>
          If you have any questions or would like to know which gift cards are
          available in your region, please contact us at{" "}
          <a
            href="mailto:team@kepithorstudios.com"
            className="text-emerald-400 hover:text-emerald-300 underline"
          >
            team@kepithorstudios.com
          </a>
          .
        </p>
      </section>
    </LegalPage>
  );
}
